module.exports = __webpack_public_path__ + "static/img/icon-comment.bdb093bf.svg";